import { FC } from 'react';

import { Slider } from '@phoenix/design-system/frontend/ui/slider/slider';
import { useBenefitsQuery } from '@phoenix/team-m/my-tool-shed/frontend/shared/raffle/use-benefits-query';
import { VoucherStatus } from '@phoenix/team-m/my-tool-shed/frontend/domain/model/benefits.model';

import { Raffle } from './raffle/raffle';
import { Voucher } from './voucher/voucher';

export const BenefitsSlider: FC = () => {
  const { data, isLoading } = useBenefitsQuery();
  const { raffles, vouchers } = data || {};

  return (
    !isLoading &&
    data && (
      <Slider
        id="benefits-slider"
        dataTestId="benefits-slider"
        className="mt-8"
        sliderOptions={{ slidesPerView: 1, spaceBetween: 10 }}
        pagination={{ clickable: true, clickableClass: 'text-center' }}
      >
        {raffles?.map((raffle) => raffle.active && !raffle.participation && <Raffle key={raffle.id} {...raffle} />)}
        {vouchers?.map((voucher) => voucher.status === VoucherStatus.Valid && <Voucher key={voucher.promotionId} {...voucher} />)}
      </Slider>
    )
  );
};
